import { jsx as _jsx } from "react/jsx-runtime";
export function AppSwitcher({ fill = '#fff', ...props }) {
    return (_jsx("svg", { viewBox: '0 0 24 24', xmlns: 'http://www.w3.org/2000/svg', ...props, fill: fill, children: _jsx("path", { d: 'M4 8h4V4H4zm6 12h4v-4h-4zm-6 0h4v-4H4zm0-6h4v-4H4zm6\n        0h4v-4h-4zm6-10v4h4V4zm-6 4h4V4h-4zm6 6h4v-4h-4zm0 6h4v-4h-4z' }) }));
}
